import { useSelector } from "react-redux";
import Icons from "../../assets/Icons";
import LoadingComponent from "../LoadingComponent/LoadingComponent";


const Current = () => {

    const latitude = useSelector(state => state.geoLocation.latitude)
    const longitude = useSelector(state => state.geoLocation.longitude)


    const city = useSelector(state => state.geoLocation.city)
    const state = useSelector(state => state.geoLocation.state)
    const country = useSelector(state => state.geoLocation.country)
    const iconId = `icon_${useSelector(state => state.weatherData.currentWeather.weather[0].icon)}`
    const icon = Icons[iconId]
    const temp = useSelector(state => state.weatherData.currentWeather.temp).toFixed(0)
    const description = useSelector(state => state.weatherData.currentWeather.weather[0].description)
    const feelsLike = useSelector(state => state.weatherData.currentWeather.feels_like).toFixed(0)
    const tempMin = useSelector(state => state.weatherData.extendedForecast[0].temp.min).toFixed(0)
    const tempMax = useSelector(state => state.weatherData.extendedForecast[0].temp.max).toFixed(0)
    const humidity = useSelector(state => state.weatherData.currentWeather.humidity)
    const wind = useSelector(state => state.weatherData.currentWeather.wind_speed).toFixed(0)



    return (
        

        <div className="current">
            
            <div className="wrapper img-temp row">       
                <h2 className="current-weather">Current Weather</h2>
                {city ? <h2 className="current-weather__location">{city}, {country}</h2> : <h2 className="current-weather__location">{state}, {country}</h2>}
                <div className="current__img">
                    <img src={icon}/>
                    
                </div>
                <h2 className="temp">{temp}°</h2>
                <p className="description">{description}</p>
            </div>
            <div className="wrapper">
                <div className="row">
                    <h3 className="feelsLike">Feels like <span>{feelsLike}°</span></h3>
                    <div className="current__minMax">
                        <div className="current__wrapper--container">
                            <div className="current__wrapper--container-img">
                                <img src={require("../../img/caret-down-solid.svg").default} />
                            </div>
                            <p><span>{tempMin}°</span></p>
                        </div>
                        <div className="current__wrapper--container">
                            <div className="current__wrapper--container-img">
                                <img src={require("../../img/caret-up-solid.svg").default} />
                            </div>
                            <p><span>{tempMax}°</span></p>
                        </div>
                    </div>
                    <div className="current__wrapper--container">
                        <div className="current__wrapper--container-img">
                            <img src={require("../../img/droplet-solid.svg").default} />
                        </div>
                        <p>Humidity <span>{humidity}%</span></p>
                    </div>
                    <div className="current__wrapper--container">
                        <div className="current__wrapper--container-img">
                            <img src={require("../../img/wind-solid.svg").default} />
                        </div>
                        <p>Wind <span>{wind}km/h</span></p>
                    </div>
                </div>  
            </div>
            


        </div>
            
        
    )

}

export default Current